import { type LegacyApiError, useApi } from '@omnipresentgroup/api';
import type {
  GetCutoffDatesRequest,
  GetCutoffDatesResponse,
} from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';

export const useCutoffDates = ({
  lspId,
  countryCode,
  legalEntityId,
  baseDate,
  cycles,
  enabled = true,
}: GetCutoffDatesRequest & { enabled?: boolean }) => {
  const { GET } = useApi();

  return useQuery<GetCutoffDatesResponse, LegacyApiError>({
    queryKey: [API_PATH, lspId, countryCode, legalEntityId, baseDate, cycles],
    queryFn: () =>
      GET<GetCutoffDatesResponse>(
        `${API_BASE}/${API_PATH}`,
        {},
        {
          ...(lspId && { lspId }),
          ...(countryCode && { countryCode }),
          ...(legalEntityId && { legalEntityId }),
          ...(baseDate && { baseDate }),
          ...(cycles && { cycles: String(cycles) }),
        },
      ),
    staleTime: Number.POSITIVE_INFINITY,
    enabled: enabled,
  });
};
